import { UniversityStudyRoomTemplate } from "@/components/UniversityStudyRoomTemplate";

const ArizonaStateUniversity = () => {
  return (
    <UniversityStudyRoomTemplate
      universityName="Arizona State University"
      universityShortName="ASU"
      slug="arizona-state-university"
      seoTitle="ASU Study Rooms | Hayden Library Study Spaces Tempe"
      seoDescription="Find study rooms at ASU including Hayden Library. Learn about reservable and drop-in rooms, booking policies, and discover CSW as an online alternative."
      seoKeywords="ASU study rooms, Hayden Library study rooms, Arizona State University, Tempe study spaces, Sun Devil study rooms"
      canonicalUrl="/study-room/arizona-state-university/"
      heroDescription="Explore ASU's 30+ study rooms at Hayden Library with options for groups and individuals."
      libraryWebsiteUrl="https://lib.asu.edu"
      libraryWebsiteName="ASU Libraries"
      studySpaces={[
        {
          name: "Hayden Library - Reservable Rooms",
          features: "18 rooms (capacity 5-8), up to 4 hours/day, book 7 days ahead.",
          feedback: "Good variety. Some complaints about noise and odor in certain rooms."
        },
        {
          name: "Hayden Library - Drop-in Rooms",
          features: "11 non-reservable rooms, first-come-first-served for individuals.",
          feedback: "Great for spontaneous solo study sessions."
        },
        {
          name: "Upper Floor Pods",
          features: "Quieter individual study pods, less foot traffic.",
          feedback: "Best for focused individual work away from crowds."
        },
        {
          name: "Wellness & Lactation Rooms",
          features: "Specialized rooms for wellness breaks and nursing mothers.",
          feedback: "Appreciated amenity for students with specific needs."
        }
      ]}
      guideContent={
        <>
          <p>
            The Hayden Library offers more than 30 study rooms; 18 rooms are reservable (capacity 5-8) for up to four hours 
            per day, with reservations available seven days in advance. Eleven non-reservable rooms are first-come-first-served.
          </p>
          <p className="mt-4">
            Students sometimes complain about noise and odor in some study rooms; people sometimes treat the library like 
            a social space. Still, many appreciate the variety of rooms and the ability to book ahead.
          </p>
          <p className="mt-4">
            Reserve one of the quieter reservable rooms for group work; for solo study, check out the non-reservable pods 
            on upper floors. Arrive early to claim your space and avoid heavily trafficked times. Bring a sweater—the AC can be chilly!
          </p>
        </>
      }
      summaryTips={[
        "18 reservable rooms, 11 drop-in rooms available",
        "Book up to 7 days in advance for reservable rooms",
        "Upper floor pods are quieter for solo study",
        "Arrive early to claim first-come spaces",
        "Bring a sweater - the AC runs cold!"
      ]}
    />
  );
};

export default ArizonaStateUniversity;
